var map = {
	"./amazonaws.svg": "1951",
	"./angular.svg": "3ae5",
	"./bootstrap.svg": "91ea",
	"./connection.svg": "f329",
	"./cplusplus.svg": "e1b5",
	"./css3.svg": "54f4",
	"./facebook.svg": "3679",
	"./html5.svg": "7d4c",
	"./hugo.svg": "4e84",
	"./instagram.svg": "476b",
	"./java.svg": "5af3",
	"./javascript.svg": "651d",
	"./linkedin.svg": "8cff",
	"./mongodb.svg": "51db",
	"./mysql.svg": "713f",
	"./python.svg": "a45f",
	"./react.svg": "f5fc",
	"./twitter.svg": "7b00",
	"./vue.svg": "2d31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4685";